// Composables
import { useTimer } from '~/composables/use-timer';

export const useTimerLabel = (title: string, timeInSeconds: number) => {
  const { time, launch: launchTimer } = useTimer(timeInSeconds);

  const timerTitle: ComputedRef<string> = computed<string>(() => {
    const timerCount: number = time.value;

    return `${title}${timerCount ? ` (${timerCount} Sec${timerCount > 1 ? 's' : ''})` : ''}`;
  });

  const isDisabled: ComputedRef<boolean> = computed<boolean>(() => !!time.value);

  return { title: timerTitle, isDisabled, launchTimer };
};
